import { render } from "./legoProgress.vue?vue&type=template&id=385b98d0"
import script from "./legoProgress.vue?vue&type=script&lang=js"
export * from "./legoProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoProgress/legoProgress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "385b98d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('385b98d0', __exports__)) {
    api.reload('385b98d0', __exports__)
  }
  
  module.hot.accept("./legoProgress.vue?vue&type=template&id=385b98d0", () => {
    api.rerender('385b98d0', render)
  })

}


export default __exports__